import ValidationHelper from 'legacy/lut/classes/helpers/partner360/ValidationHelper'

import type { PartnerDevicesInfoDraft } from '../model/types'

export const parseDraftNumber = (value: string): number | null => {
  const trimmed = value.trim()

  if (trimmed === '') {
    return null
  }

  const normalized = trimmed.replace(',', '.')
  const parsed = Number(normalized)

  return Number.isFinite(parsed) ? parsed : null
}

export const formatDisplayNumber = (
  value: number | null | undefined,
  options?: {
    minimumFractionDigits?: number
    maximumFractionDigits?: number
  }
) => {
  if (value == null) {
    return '-'
  }

  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: options?.minimumFractionDigits ?? 0,
    maximumFractionDigits: options?.maximumFractionDigits ?? 0,
  }).format(value)
}

export const getPercentDisplay = (hpBrand: number | null, allBrands: number | null) => {
  const percent = ValidationHelper.calcPercent(hpBrand ?? undefined, allBrands ?? undefined, true)
  return ValidationHelper.getPercentValue(percent)
}

export const getDraftPercent = (hpBrand: string, allBrands: string) => {
  return getPercentDisplay(parseDraftNumber(hpBrand), parseDraftNumber(allBrands))
}

export const normalizeDraftForCompare = (draft: PartnerDevicesInfoDraft) => ({
  a3AllBrands: parseDraftNumber(draft.a3AllBrands),
  a3HpBrand: parseDraftNumber(draft.a3HpBrand),
  a4AllBrands: parseDraftNumber(draft.a4AllBrands),
  a4HpBrand: parseDraftNumber(draft.a4HpBrand),
  overLastYears: draft.overLastYears,
})
